import React from 'react'
import ResinousApplicationList from './ResinousApplicationList'

export default function ResinousApplicationSelection() {
   return (
      <React.Fragment>
         <div className="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
            <ResinousApplicationList />
         </div>
      </React.Fragment>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/resinous/ResinousApplicationSelection.js